// App.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReservaHome from './components/Reserva/ReservaHome';
import AvailableRooms from './components/Reserva/AvailableRooms';
import AvailableRoomsBoutique from './components/ReservaBoutique/AvailableRoomsBoutique';
import Home from './components/Home/home';
import { AnimationProvider } from './context/AnimationContext';
import './App.css';
import Boutique from './components/ReservaBoutique/ReservaHomeBoutique';
import Bodas from './components/Bodas/Bodas';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navigation/Navbar';
import Dashboard from './components/dashboard/Dashboard';
import GuestAssignmentForm from './components/dashboard/components/GuestAssignmentForm';
import FloatingChatBot from './components/FloatingChatBot/FloatingChatBot';

// Lazy load FloatingWidgets (Leaflet is ~140KB gzipped)
const FloatingWidgets = React.lazy(() => import('./components/Home/FloatingWidgets'));

// Componente wrapper para manejar la lógica del Navbar
function AppContent() {
  const location = useLocation();
  
  // Rutas donde NO queremos mostrar el Navbar
  const hideNavbarRoutes = ['/dashboard',];
  
  // Rutas donde NO queremos mostrar el chatbot flotante
  const hideChatBotRoutes = ['/dashboard', '/guest-assignment'];
  
  // Verificar si la ruta actual debe ocultar el Navbar
  const shouldHideNavbar = hideNavbarRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  const shouldHideChatBot = hideChatBotRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <div className="App">
      {/* Solo mostrar Navbar si NO estamos en rutas de dashboard */}
      {!shouldHideNavbar && <Navbar />}
      
      <ScrollToTop />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reservas" element={<ReservaHome />} />
        <Route path="/habitaciones-disponibles" element={<AvailableRooms />} />
        <Route path="/habitaciones-boutique" element={<AvailableRoomsBoutique />} />
        <Route path="/boutique" element={<Boutique />} />
        <Route path="/bodas" element={<Bodas />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/guest-assignment/:token" element={<GuestAssignmentForm />} />
      
      </Routes>

      {/* Chatbot flotante solo en páginas públicas */}
      {!shouldHideChatBot && <FloatingChatBot />}
      {!shouldHideChatBot && (
        <Suspense fallback={null}>
          <FloatingWidgets />
        </Suspense>
      )}
    </div>
  );
}

function App() {
  return (
    <AnimationProvider>
      <Router>
        <AppContent />
      </Router>
    </AnimationProvider>
  );
}

export default App;